/** action_msgs/GoalStatus codes — https://docs.ros2.org/latest/api/action_msgs/msg/GoalStatus.html */
export const NAVIGATE_GOAL_STATUS = {
    SUCCEEDED: 4,
    CANCELED: 5,
    ABORTED: 6,
};

export const NAVIGATE_GOAL_STATUS_OPTIONS = [
    { value: "SUCCEEDED", label: "Succeeded" },
    { value: "CANCELED", label: "Canceled" },
    { value: "ABORTED", label: "Aborted" },
];

export const NAVIGATE_STATUS_SOURCE_ID = "navigate_status";
/** @deprecated Legacy NavigateTo status topic; Cancel mission now uses mission state. */
export const NAVIGATE_STATUS_TOPIC = "/navigate_to_pose/_action/status";
export const MISSION_STATE_TOPIC = "/mission_executor/state";
export const MISSION_CANCEL_EVENT_FIELD = "mission_cancel_event";
/** @deprecated Prefer MISSION_CANCEL_EVENT_FIELD */
export const NAVIGATE_CANCEL_EVENT_FIELD = "nav_cancel_event";
/** @deprecated Prefer MISSION_CANCEL_EVENT_FIELD */
export const NAVIGATE_CANCELED_FIELD = "mission_cancel_event";

const LEGACY_NUMERIC_TO_NAME = {
    "4": "SUCCEEDED",
    "5": "CANCELED",
    "6": "ABORTED",
};

const LEGACY_CANCEL_FIELDS = new Set([
    MISSION_CANCEL_EVENT_FIELD,
    NAVIGATE_CANCEL_EVENT_FIELD,
    "has_canceled",
]);

export const isNavigateCanceledSource = (source) =>
    source?.kind !== "mission_step_failure" &&
    (source?.id === NAVIGATE_STATUS_SOURCE_ID ||
        source?.field === MISSION_CANCEL_EVENT_FIELD ||
        source?.field === NAVIGATE_CANCEL_EVENT_FIELD ||
        source?.field === "has_canceled" ||
        (source?.value_type === "boolean" &&
            (source?.topic === MISSION_STATE_TOPIC || source?.topic === NAVIGATE_STATUS_TOPIC)));

export const isNavigateGoalStatusEnumSource = (source) => source?.value_type === "enum";

export const isNavigateCanceledCondition = (condition) =>
    LEGACY_CANCEL_FIELDS.has(condition?.field) &&
    (condition?.topic === MISSION_STATE_TOPIC ||
        condition?.topic === NAVIGATE_STATUS_TOPIC ||
        !condition?.topic);

export const isNavigateStatusSource = (source) =>
    source?.id === NAVIGATE_STATUS_SOURCE_ID ||
    isNavigateCanceledSource(source) ||
    isNavigateGoalStatusEnumSource(source);

const normalizeMissionCancelCondition = (condition) => ({
    ...condition,
    topic: MISSION_STATE_TOPIC,
    field: MISSION_CANCEL_EVENT_FIELD,
    operator: "eq",
    value: "true",
});

const normalizeLegacyNavigateStatusCondition = (condition) => {
    const rawValue = String(condition.value ?? "").trim();
    let value = rawValue;

    if (LEGACY_NUMERIC_TO_NAME[rawValue]) {
        value = LEGACY_NUMERIC_TO_NAME[rawValue];
    } else if (condition.operator === "in" && rawValue) {
        const first = rawValue.split(",")[0]?.trim();
        value = LEGACY_NUMERIC_TO_NAME[first] ?? first?.toUpperCase() ?? "";
    } else {
        value = rawValue.toUpperCase();
    }

    if (!NAVIGATE_GOAL_STATUS_OPTIONS.some((option) => option.value === value)) {
        value = NAVIGATE_GOAL_STATUS_OPTIONS[0].value;
    }

    return {
        ...condition,
        operator: "is",
        value,
    };
};

export const normalizeNavigateStatusCondition = (condition) => {
    if (isNavigateCanceledCondition(condition) || condition.field === "has_canceled") {
        return normalizeMissionCancelCondition(condition);
    }

    if (condition.topic === NAVIGATE_STATUS_TOPIC) {
        return normalizeLegacyNavigateStatusCondition(condition);
    }

    return condition;
};

export const normalizeBehaviourCondition = (condition, source) => {
    if (isNavigateCanceledSource(source) || isNavigateCanceledCondition(condition)) {
        return normalizeMissionCancelCondition({
            ...condition,
            topic: source?.topic ?? condition.topic ?? MISSION_STATE_TOPIC,
            field: MISSION_CANCEL_EVENT_FIELD,
        });
    }

    if (condition.topic === NAVIGATE_STATUS_TOPIC || condition.topic === MISSION_STATE_TOPIC) {
        return normalizeNavigateStatusCondition(condition);
    }

    return condition;
};

export const isTerminalNavigateGoalStatus = (code) => {
    if (code == null) return false;
    return (
        code === NAVIGATE_GOAL_STATUS.SUCCEEDED ||
        code === NAVIGATE_GOAL_STATUS.CANCELED ||
        code === NAVIGATE_GOAL_STATUS.ABORTED
    );
};
